import { render, staticRenderFns } from "./dict.vue?vue&type=template&id=0a60d728&scoped=true"
import script from "./dict.vue?vue&type=script&lang=js"
export * from "./dict.vue?vue&type=script&lang=js"
import style0 from "./dict.vue?vue&type=style&index=0&id=0a60d728&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a60d728",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a60d728')) {
      api.createRecord('0a60d728', component.options)
    } else {
      api.reload('0a60d728', component.options)
    }
    module.hot.accept("./dict.vue?vue&type=template&id=0a60d728&scoped=true", function () {
      api.rerender('0a60d728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dict.vue"
export default component.exports